import { getSignUrl, uploadFile } from '../api';
import { useState, useCallback } from 'react';
import generateFileName from '../utils/generateFileName';
import {
  useOrganizationBusy,
  useOrganizationScopeOrNull,
} from '../components/OrganizationScope/context';

function useUploadFile() {
  const [loading, setLoading] = useState<boolean>(false);
  // アップロードは axios の mutation を経由しないため busy 登録する
  const { beginBusy, endBusy } = useOrganizationBusy();
  // 複数ファイルの途中で戻る/進むにより組織が変わっても、開始時の組織へ上げる
  const organizationId = useOrganizationScopeOrNull()?.organizationId ?? null;

  const uploadToS3 = useCallback(
    async ({ files }: { files: File[] }) => {
      beginBusy();
      try {
        setLoading(true);
        return await Promise.all(
          files.map(async (file) => {
            const res = await getSignUrl(
              {
                filename: generateFileName(file),
                contentType: file.type,
                size: file.size,
              },
              organizationId,
            );
            await uploadFile(res.preSignedUrl, file);
            return res;
          })
        );
      } finally {
        setLoading(false);
        endBusy();
      }
    },
    [beginBusy, endBusy, organizationId]
  );

  return { loading, uploadToS3 };
}

export default useUploadFile;
